import React, { useState, useEffect, useCallback } from 'react';
import { InputText, ImageUpload, DropdownField } from 'components/common/input';
import BaseModalForm from 'components/common/modal/BaseModalForm';
import { useFormHandlers } from 'core/hooks/form/formHandlers';
import { Alert } from 'react-bootstrap';
import { MODAL_FORM_ERRORS } from 'core/constant/MODAL_FORM_ERRORS';

const EditCommentModal = ({ show, comment, handleClose, handleSave, updating, errors, blogOptions, requestError }) => {
  const [formValues, setFormValues] = useState(comment);
  const { handleChange, handleFileChangeLocal, handleRemoveImageLocal } = useFormHandlers(setFormValues);

  useEffect(() => {
    setFormValues(comment);
  }, [comment]);

  const handleSaveClick = useCallback(() => {
    handleSave({ ...formValues, id: comment?.id });
  }, [formValues, comment?.id, handleSave]);

  return (
    <BaseModalForm show={show} title={comment?.id ? "Editar Comentario" : "Crear Comentario"} handleClose={handleClose} handleSave={handleSaveClick} updating={updating}>
      <div className="row">
        <div className="col-md-6 form-group">
          <DropdownField
            label="Blog"
            value={formValues?.blog_id}
            options={blogOptions}
            onChange={(e) => handleChange('blog_id', e.target.value)}
            placeholder="Seleccione el blog"
            error={errors.blog_id}
          />
        </div>
        <div className="col-md-6 form-group">
          <ImageUpload
            label="Imagen del Cometario"
            value={formValues?.image}
            onFileChange={(e) => handleFileChangeLocal(e, 'image')}
            onRemoveImage={() => handleRemoveImageLocal('image')}
            error={errors.image}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Titulo del comentario"
            value={formValues?.author_name}
            onChange={(e) => handleChange('author_name', e.target.value)}
            placeholder="Ingrese el titulo del comentario"
            error={errors.author_name}
          />
        </div>
        <div className="col-md-6 form-group">
          <ImageUpload
            label="Imagen referencial al titulo"
            value={formValues?.author_image}
            onFileChange={(e) => handleFileChangeLocal(e, 'author_image')}
            onRemoveImage={() => handleRemoveImageLocal('author_image')}
            error={errors.author_image}
          />
        </div>
        <div className="col-md-6 form-group">
          <InputText
            label="Subtitulo del comentario"
            value={formValues?.author_designation}
            onChange={(e) => handleChange('author_designation', e.target.value)}
            placeholder="Ingrese el subtitulo del comentario"
            error={errors.author_designation}
          />
        </div>
        <div className="col-12 form-group mt-3">
          {requestError &&
            <Alert variant="danger">
              {requestError?.response?.data?.message ||
               MODAL_FORM_ERRORS.COMMENT}
            </Alert>
          }
        </div>
      </div>
    </BaseModalForm>
  );
};

export default React.memo(EditCommentModal);
